import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './GuestBanner.css';

interface GuestBannerProps {
  onUpgrade: () => void;
}

export default function GuestBanner({ onUpgrade }: GuestBannerProps) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="guest-banner">
      <span className="guest-banner-text">
        {t('auth.guestBanner')} {t('auth.guestBannerCta')}
      </span>
      <button className="guest-banner-upgrade" onClick={onUpgrade}>
        {t('auth.guestUpgrade')}
      </button>
      <button
        className="guest-banner-close"
        onClick={() => setDismissed(true)}
        aria-label={t('common.close')}
      >
        &times;
      </button>
    </div>
  );
}
